module.exports = __webpack_public_path__ + "img/thegamma2collection.88e6131a.png";